require('./SectionBadge.less');
